import Api from '/app/services/api';
import Polling from '/app/services/polling';
import { config } from '/app/config';
import { defineAppPlugin } from '/app/utils/app';

export const api = new Api({
  baseURL: config.api.baseURL,
  timeout: 70000,
});
export const polling = new Polling({
  baseURL: config.api.baseURL,
  timeout: 70000,
});

export const fetcher = async (...args) => {
  const response = await api.requester.get(...args);
  return response.data;
}

export default defineAppPlugin(() => {});
